export default "__VITE_ASSET__f0gQHZPg__"